import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useCallback, useMemo, useEffect } from "react";
import { SnackbarQueuer } from "sprout-ui-dom/dist/Snackbar";
import useCurrentUser from "@sprout/client-graphql/dist/useCurrentUser";
import { App_SubscriptionDocument, App_UserItemPreferenceSubscriptionDocument } from "sprout-graphql";
import useEventListener from "@sprout/hooks/dist/useEventListener";
import { throttle } from "lodash";
import { scrollTop, addClass, removeClass } from "dom-helpers";
import JumpTo from "@sprout/client-components/dist/JumpTo";
import { AuthenticationDialog } from "@sprout/client-components/dist/Dialog_next";
import { active, // WindowFocusRefetchQuery,
FeatureFlaggedSubscription } from "@sprout/client-lib/dist";
import { bootIntercom } from "../intercom";
import GlobalKeyboardShortcuts from "./GlobalKeyboardShortcuts";
import AppRoutes from "./App_Routes";
import AppHelpMenu from "./AppHelpMenu";
import GlobalCreatePost from "./GlobalCreatePost";
import TimezoneDetector from "./TimezoneDetector";
const isScrolled = "is-scrolled";
const App = ()=>{
    const currentUser = useCurrentUser();
    const throttledScroll = useMemo(()=>throttle((docScrollTop)=>{
            if (docScrollTop > 0) addClass(document.body, isScrolled);
            else removeClass(document.body, isScrolled);
        }, 300), []);
    const handleScroll = useCallback(()=>{
        throttledScroll(scrollTop(document.documentElement));
    }, [
        throttledScroll
    ]);
    useEventListener("scroll", handleScroll);
    useEffect(()=>{
        bootIntercom(currentUser);
    }, [
        currentUser
    ]);
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            (!currentUser || !active(currentUser)) && /*#__PURE__*/ _jsx(AuthenticationDialog, {}),
            active(currentUser) && /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsx(JumpTo, {}),
                    /*#__PURE__*/ _jsx(TimezoneDetector, {}),
                    /*#__PURE__*/ _jsx(FeatureFlaggedSubscription, {
                        subscription: App_SubscriptionDocument
                    }),
                    /*#__PURE__*/ _jsx(FeatureFlaggedSubscription, {
                        subscription: App_UserItemPreferenceSubscriptionDocument
                    }),
                    /*#__PURE__*/ _jsx(GlobalKeyboardShortcuts, {}),
                    /*#__PURE__*/ _jsx(GlobalCreatePost, {}),
                    /*#__PURE__*/ _jsx(AppHelpMenu, {})
                ]
            }),
            /*#__PURE__*/ _jsx(SnackbarQueuer, {}),
            /*#__PURE__*/ _jsx(AppRoutes, {})
        ]
    });
};
export default App;
